<template>
  <div class="page">
    <div class="page-title">Purchase Labels</div>
    <div class="page-content">
      <div v-if="!$route.params.locationId">
        <h4 class="text-center">
          Select the nodes for which you wish to print labels.
        </h4>
        <PurchaseList :loading="isLoading"></PurchaseList>
      </div>
    </div>
  </div>
</template>

<script>
import PurchaseList from "@/components/PurchaseList";

export default {
  name: "purchase",
  components: {
    PurchaseList,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {},
  computed: {
    nodeType() {
      return this.$route.params.nodeType;
    },
  },
  async mounted() {},
};
</script>

<style lang="scss" scoped>
.nodes {
  margin: auto;
  margin-top: 15px;
  max-width: 360px;

  @media screen and (min-width: 768px + 250px + 50px) {
    max-width: 768px;
  }
}

.breadcrumbs {
  .link {
    &:after {
      content: " • ";
    }
  }
}
</style>
